import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './error-page/not-found/not-found.component';

const routes: Routes = [{ path: '**', component: NotFoundComponent }];

export const APP_ROUTES = RouterModule.forRoot(routes, {
  scrollPositionRestoration: 'top'
});
